import React from "react";
import { Box, Tooltip, TooltipProps } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type Props = {
  title: NonNullable<TooltipProps["title"]>;
  placement?: TooltipProps["placement"];
  size?: "small" | "inherit" | "medium";
  inline?: boolean;
  sx?: TooltipProps["componentsProps"] extends infer _U
    ? React.ComponentProps<typeof Box>["sx"]
    : never;
};

const InfoTooltip = ({
  title,
  placement = "top",
  size = "small",
  inline = false,
  sx,
}: Props) => {
  return (
    <Tooltip title={title} placement={placement} arrow>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          ml: 0.5,
          verticalAlign: "middle",
          color: "text.secondary",
          cursor: "help",
          ...(inline ? {} : {}),
          ...sx,
        }}
      >
        <InfoOutlinedIcon fontSize={size} />
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
